module.exports = __webpack_public_path__ + "static/img/3areaA_1.f4b8477.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/3areaA_1.png
// module id = 959
// module chunks = 1